/**
 * `GaestezahlAbweichungHinweis` — nur noch der RESTFALL (Antoine-Fehlerbericht 15.10.2026: „Das
 * muss überall gleich sein“). Seit dem Fix gibt es EINE Gästezahl je Vorgang: ändert sich
 * `events.guest_count`, zieht der Server alle Varianten mit und rechnet neu
 * (`apps/api/src/lib/event-patch.ts`). Eine Abweichung bleibt nur noch bei
 *  - Altfällen von vor dem Fix — der Knopf gleicht alle Varianten an (PATCH des Vorgangs mit
 *    derselben Zahl, der Server zieht nach), und
 *  - angenommenen Angeboten (`OFFER_LOCKED_STATUSES`, ab `offer_chosen`) — dort ändert der Server
 *    bewusst nichts still; der Knopf ist gesperrt und der Sperr-Hinweis erklärt warum.
 * Ohne Abweichung rendert die Komponente nichts.
 */
import { GESPERRT_HINWEIS, ROW_LABEL } from "./eckdaten-stile";

export interface GaestezahlAbweichungHinweisProps {
  /** Die Gästezahl der Veranstaltung (`events.guest_count`), an anderer Stelle editierbar. */
  guestCount: number;
  zielAngebot: { id: string; guestCount: number; label: string };
  /** `OFFER_LOCKED_STATUSES` (Spiegel `lib/offer-lock.ts`). */
  angebotGesperrt: boolean;
  uebernehmenBusy: boolean;
  onUebernehmen: () => void;
}

export function GaestezahlAbweichungHinweis({
  guestCount,
  zielAngebot,
  angebotGesperrt,
  uebernehmenBusy,
  onUebernehmen,
}: GaestezahlAbweichungHinweisProps) {
  if (zielAngebot.guestCount === guestCount) return null;

  return (
    <div className="rounded-lg border border-outline-variant/40 p-3 dark:border-outline/30" data-testid="eckdaten-gaeste-angebot">
      <div className="flex items-center justify-between gap-2">
        <span className={ROW_LABEL}>Gäste im Angebot (Variante {zielAngebot.label})</span>
        <span className="font-body-sm text-body-sm font-semibold text-on-background dark:text-inverse-on-surface">
          {zielAngebot.guestCount}
        </span>
      </div>
      <button
        type="button"
        className="mt-2 font-label-md text-[12px] text-primary hover:underline disabled:cursor-not-allowed disabled:text-secondary disabled:no-underline"
        data-testid="eckdaten-gaeste-uebernehmen"
        disabled={angebotGesperrt || uebernehmenBusy}
        title={angebotGesperrt ? GESPERRT_HINWEIS : undefined}
        onClick={onUebernehmen}
      >
        {uebernehmenBusy ? "Wird angeglichen …" : `Angebot auf ${guestCount} Gäste angleichen`}
      </button>
      {angebotGesperrt && (
        <p className="mt-1 font-body-sm text-[11px] text-secondary dark:text-secondary-fixed-dim">{GESPERRT_HINWEIS}</p>
      )}
    </div>
  );
}
